import { JSX } from "react";

export function TriggerTestError(): JSX.Element {
  throw new Error("Test error");
}
